import { render, staticRenderFns } from "./ResourceInfo.vue?vue&type=template&id=7df6deba&scoped=true"
import script from "./ResourceInfo.vue?vue&type=script&lang=js"
export * from "./ResourceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df6deba",
  null
  
)

export default component.exports